export enum ToolType {
  ELLIPSE = 'ellipse',
  IMAGE = 'image',
  LINE = 'line',
  PAN = 'pan',
  POLYLINE = 'polyline',
  RECTANGLE = 'rectangle',
  SELECT = 'select',
  STICKY = 'sticky',
  TEXT = 'text',
  CAUSE_MAP = 'causeMap',
  COMMENT = 'comment',
  DATA_GRID = 'dataGrid',
  CLOUD = 'cloud',
}
